import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = $localize`:pagination:Items per page`;
  override nextPageLabel = $localize`:pagination:Next`;
  override previousPageLabel = $localize`:pagination:Previous`;
  override firstPageLabel = $localize`:pagination:First page`;
  override lastPageLabel = $localize`:pagination:Last page`;

  private rangeLabel = $localize`:pagination:of`;

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.rangeLabel} ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${this.rangeLabel} ${length}`;
  };
}
